(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["londa-line-floating"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('londa-line-help')) {
  customElements.define('londa-line-help', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.details = this.querySelector('details');
      this.trigger = this.querySelector('summary');
      const closeButton = this.querySelector('[data-line-help-close]');
      if (!this.details || !this.trigger || !closeButton) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      closeButton.hidden = false;
      this.trigger.setAttribute('aria-expanded', String(this.details.open));
      this.details.addEventListener('toggle', () => {
        this.trigger.setAttribute('aria-expanded', String(this.details.open));
      }, options);
      closeButton.addEventListener('click', () => this.closePanel(true), options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.details.open) {
          event.preventDefault();event.stopPropagation();this.closePanel(true);
        }
      }, options);
      document.addEventListener('pointerdown', event => {
        if (this.details.open && !event.composedPath().includes(this)) this.closePanel(false);
      }, options);
    }
    closePanel(returnFocus) {
      this.details.open = false;
      this.trigger.setAttribute('aria-expanded', 'false');
      if (returnFocus) this.trigger.focus({preventScroll: true});
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
